import { TextField } from '@adobe/react-spectrum';
import Search from '@spectrum-icons/workflow/Search';
import p from 'prop-types';
import qs from 'query-string';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useDebounce } from '@exchange-frontends/custom-hooks';

export const SearchField = (props) => {
  const navigate = useNavigate();
  const q = qs.parse(location.search).q ?? '';
  const [searchTerm, setSearchTerm] = useState(q);
  const debouncedSearchTerm = useDebounce(searchTerm, 1500);
  const sortByChangedByUser = sessionStorage.getItem('sortByChangedByUser');

  const updateUrlSearchParam = (value = '') => {
    if (value !== q) {
      const sort = sortByChangedByUser ? qs.parse(location.search).sort : 'RELEVANCE';
      if (value.length > 0 || (value.length === 0 && q)) {
        navigate({
          search: qs.stringify({
            ...qs.parse(location.search),
            q: value.length > 0 ? value : undefined,
            page: 1,
            sort,
          }),
        });
      }
    }
  };

  //  this updates the URL with the internal search state
  useEffect(() => {
    const q = qs.parse(location.search).q ?? '';
    if (debouncedSearchTerm !== q && debouncedSearchTerm) {
      const sort = sortByChangedByUser ? qs.parse(location.search).sort : 'RELEVANCE';
      if (debouncedSearchTerm.length > 2 || (debouncedSearchTerm.length === 0 && q)) {
        navigate({
          search: qs.stringify({
            ...qs.parse(location.search),
            q: debouncedSearchTerm.length > 0 ? debouncedSearchTerm : undefined,
            page: 1,
            sort,
          }),
        });
      }
    }
  }, [debouncedSearchTerm, navigate, sortByChangedByUser]);

  // this updates the internal state with the URL value
  useEffect(() => {
    if (q !== searchTerm) {
      setSearchTerm(q);
    }
  }, [q]);

  return (
    <TextField
      isQuiet={props.isQuiet}
      type="search"
      label={props.hideLabel ? null : 'Search'}
      value={searchTerm}
      placeholder="Name or keyword"
      icon={<Search />}
      onChange={setSearchTerm}
      marginBottom="size-300"
      marginTop={props.marginTop}
      width={props.width}
      maxWidth={props.maxWidth}
      onKeyUp={(e) => e.key === 'Enter' && updateUrlSearchParam(e.target.value)}
    />
  );
};

SearchField.propTypes = {
  isQuiet: p.bool,
  hideLabel: p.bool,
  marginTop: p.string,
  width: p.string,
  maxWidth: p.string,
};

SearchField.defaultProps = {
  isQuiet: true,
  hideLabel: false,
};
